import '@material/web/dialog/dialog.js';

export class HomeTabActions {
    autoDialog;
    rentersDialog;

    goToAutoBundle = (obj) => {
        let url = '';
        const isCustomAuto = ($('#CustomAutoPageUrl').val() !== null && $('#CustomAutoPageUrl').val() !== '' && $('#CustomAutoPageUrl').val() !== undefined);
        const isCustomRenters = ($('#CustomRentersPageUrl').val() !== null && $('#CustomRentersPageUrl').val() !== '' && $('#CustomRentersPageUrl').val() !== undefined);
        const isCustomAutoRenters = ($('#CustomAutoRentersPageUrl').val() !== null && $('#CustomAutoRentersPageUrl').val() !== '' && $('#CustomAutoRentersPageUrl').val() !== undefined);
        const value = $(obj).text();

        if (value === 'Auto Only') {
            url = isCustomAuto ? $('#CustomAutoPageUrl').val() : $('#AutoLink').val();
        } else if (value === 'Renters Only') {
            url = isCustomRenters ? $('#CustomRentersPageUrl').val() : $('#RentersLink').val();
        }
        else {
            url = isCustomAutoRenters ? $('#CustomAutoRentersPageUrl').val() : $('#AutoRentersQuoteUrl').val();
        }

        window.location.href = url;
    };

    selectedProducts = [];

    checkSelectedProducts = () => {
        const messages = $('.productValMsg');
        const hideClass = 'f-display-none';
        const mdcMsg = $('#SelectProduct').parent();
        const mdcClass = 'mdc-select--invalid';
        if (this.selectedProducts.length) {
            messages.addClass(hideClass);
            mdcMsg.removeClass(mdcClass);
        }
        else {
            messages.removeClass(hideClass);
            mdcMsg.addClass(mdcClass);
        }
    };

    initialize = () => {
        // this jQuery all needs to die in a fire, the material components have js interfaces for a reason
        this.autoDialog = MDCDialog.attachTo(document.querySelector('.auto-dialog'));
        this.rentersDialog = MDCDialog.attachTo(document.querySelector('.renters-dialog'));

        $('.home-tab-actions').on('MDCTabBar:activated', (event) => {
            const index = event.detail.index;
            const tabPane = $('.tab-pane[data-tab-id=' + index + ']');
            const oldTabPane = $('.tab-pane--active');

            oldTabPane.removeClass('tab-pane--active');
            tabPane.addClass('tab-pane--active');
        });

        $('.home-tab-actions').on('click', '#findAgentLink', this.handleAgentSubmission);
        $('.home-tab-actions').on('click', '#getQuoteLink', this.handleQuoteSubmission);

        $('.home-tab-actions').on('click', '.ifbi-chip', () => {
            this.getSelectedProducts();
            this.toggleGetQuoteButton();
            this.checkSelectedProducts();
        });

        $('.home-tab-actions').on('keyup change', '#FindAgentZipCode', () => {
            this.toggleFindAgentButton();
        });

        $('.home-tab-actions').on('change', '#SelectProduct', (ev) => {
            const product = ev.currentTarget.value;

            this.selectedProducts = [];
            if (product !== null && product.length > 0) {
                this.selectedProducts.push(product);
            }

            this.toggleGetQuoteButton();
            this.checkSelectedProducts();
        });
    }

    handleAgentSubmission = (form) => {
        const zipCodeField = $('#FindAgentZipCode');
        const zipCode = zipCodeField.val();
        let findAgentUrl = $('#FindAnAgentUrl').val();

        const isValid = this.isZipCodeValid(zipCode);

        if (!isValid) {
            zipCodeField.parent().addClass('mdc-text-field--invalid');
        } else {
            zipCodeField.parent().removeClass('mdc-text-field--invalid');
            form.submit();
        }
    };

    handleQuoteSubmission = () => {
        this.checkSelectedProducts();

        let queryString = '';

        //Get queryString based on selectedProducts array
        queryString = this.getQueryString(this.selectedProducts);


        let quoteUrl = '';

        if (this.selectedProducts.length > 2) {
            quoteUrl = $('#GeneralQuoteUrl').val() + queryString;
        } else if (this.selectedProducts.length === 2) {
            if (this.selectedProducts.includes('Auto') && this.selectedProducts.includes('Renters')) {
                // Auto+Renters
                quoteUrl = ($('#CustomAutoRentersPageUrl').val() == null || $('#CustomAutoRentersPageUrl').val() == '' || $('#CustomAutoRentersPageUrl').val() == undefined) ? $('#AutoRentersQuoteUrl').val() : $('#CustomAutoRentersPageUrl').val();
            } else {
                quoteUrl = $('#GeneralQuoteUrl').val() + queryString;
            }
        } else if (this.selectedProducts.length > 0) {
            const product = this.selectedProducts[0];

            switch (product) {
                case 'Auto':
                    this.autoDialog.open();
                    break;
                case 'Renters':
                    this.rentersDialog.open();
                    break;
                case 'Home':
                    quoteUrl = $('#HomeQuoteUrl').val();
                    break;
                case 'Life':
                    quoteUrl = $('#LifeQuoteUrl').val() + queryString;
                    break;
                case 'Business':
                    quoteUrl = $('#BusinessQuoteUrl').val() + queryString;
                    break;
                case 'FarmCrop':
                    quoteUrl = $('#FarmCropQuoteUrl').val() + queryString;
                    break;
            }
        }
        if (quoteUrl.length > 0) {
            window.location.assign(quoteUrl);
        }
    };

    getSelectedProducts = () => {
        const selectedChips = $('.mdc-chip--selected');
        this.selectedProducts = [];

        if (selectedChips.length === 0) {
            return this.selectedProducts;
        }

        for (let i = 0; i < selectedChips.length; i++) {
            this.selectedProducts.push(selectedChips[i].dataset.product);
        }

        return this.selectedProducts;
    };

    toggleGetQuoteButton = () => {
        const button = $('#getQuoteLink');

        if (this.selectedProducts.length > 0) {
            button.removeClass('disabled');
        } else {
            button.addClass('disabled');
        }
    };

    toggleFindAgentButton = () => {
        const zipCode = $('#FindAgentZipCode').val();
        const button = $('#findAgentLink');

        if (zipCode.length > 0) {
            button.removeClass('disabled');
        } else {
            button.addClass('disabled');
        }
    };

    getQueryString = (selectedProductsArray) => {
        let queryString = '';
        let productcount = selectedProductsArray.length;
        let quoteRequest = '';
        if (productcount >= 2) {

            for (let count = 0; count < productcount; count++) {
                let selectedProduct = '';
                //Separate space in "FarmCrop"
                if (selectedProductsArray[count] === "FarmCrop") {
                    selectedProduct = 'Farm%20Crop';
                }
                else {
                    selectedProduct = selectedProductsArray[count];
                }
                //Adding ',' or ', and' to string
                quoteRequest += selectedProduct + (count < (productcount - 2) ? ',%20' : (count === (productcount - 2) ? ',%20and%20' : ''));
            }

            queryString = '?quote=true&topic=general&comments=' + quoteRequest + '%20Quote%20Request';
        }
        else if (productcount > 0) {
            const product = selectedProductsArray[0];
            switch (product) {
                case 'Life':
                    queryString = '?quote=true&topic=life&comments=Life%20Quote%20Request';
                    break;
                case 'Business':
                    queryString = '?quote=true&topic=business&comments=Business%20Quote%20Request';
                    break;
                case 'FarmCrop':
                    queryString = '?quote=true&topic=farm&comments=Farm%20Crop%20Quote%20Request';
                    break;
            }
        }
        return queryString;
    };

    isZipCodeValid = (ZipCode) => /(^\d{5}$)|(^\d{5}-\d{4}$)|(^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,8}.-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,8})/.test(ZipCode);
}